import { render, staticRenderFns } from "./z_auxiliary_box.vue?vue&type=template&id=5a66809e&scoped=true&"
import script from "./z_auxiliary_box.vue?vue&type=script&lang=js&"
export * from "./z_auxiliary_box.vue?vue&type=script&lang=js&"
import style0 from "./z_auxiliary_box.vue?vue&type=style&index=0&id=5a66809e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a66809e",
  null
  
)

export default component.exports